import { NavTabs } from '@yuno/design-system-web'
import { FiltersInputSearch } from '../../components/filters/input-search'
import { ContainerSearch, PageTitle } from '../../components/filters/styles'
import ExplorePage from '../explore'
import YourConnectionsPage from '../your-connections'
import { useTranslation } from 'react-i18next'

const ConnectionsPage = () => {
  const { t } = useTranslation()
  const tabsConnections = [
    {
      label: t('explore'),
      content: <ExplorePage />,
    },
    {
      label: t('yourConnections'),
      content: <YourConnectionsPage />,
    },
  ]

  return (
    <div>
      <ContainerSearch>
        <PageTitle>{t('connections')}</PageTitle>
      </ContainerSearch>
      <NavTabs tabs={tabsConnections} />
    </div>
  )
}

export default ConnectionsPage
